"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/web.timers.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGodsEyeContext = useGodsEyeContext;
exports["default"] = exports.GodsEyeProvider = exports.GodsEyeContext = exports.WIDGET_EVENT = exports.WIDGET_TITLE = exports.MEEPSHOP_EVENT = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _reactVisibilitySensor = _interopRequireDefault(require("react-visibility-sensor"));

var _emptyFunction = _interopRequireDefault(require("fbjs/lib/emptyFunction"));

var _AdTrack = _interopRequireDefault(require("./AdTrack"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-nocheck
var MEEPSHOP_EVENT = {
  click: 'meepShop_click',
  view: 'meepShop_view',
  retention: 'meepShop_retention'
}; // 名稱與後台需 Match

exports.MEEPSHOP_EVENT = MEEPSHOP_EVENT;
var WIDGET_TITLE = {
  carousel: '圖片輪播',
  'product-video': '商品影片',
  'product-service': '商品問答',
  products: '商品列表-預設',
  'products-controlled': '商品列表',
  'product-collections': '商品照片集',
  'product-carousell': '商品主圖',
  'product-info': '商品細節',
  'product-content': '商品內容',
  'product-draftText': '商品文字',
  'facebook-wall': '臉書牆',
  'social-thumbs': '臉書按讚',
  'social-media': '社群分享',
  'video-core': '影片',
  activity: '選選樂',
  image: '圖片',
  imagetext: '圖片文字',
  iframe: '語法',
  divider: '間距',
  'draft-text': '文字',
  googlemap: '地圖',
  menu: '選單',
  'global-carousel': '全站廣告'
}; // SPEC: https://www.notion.so/specification/1-5-98145ae9d48644b1b44b9b815df4f00d

exports.WIDGET_TITLE = WIDGET_TITLE;
var WIDGET_EVENT = {
  // 圖片元件
  image: {
    view: {
      event_category: '圖片',
      event_action: 'normal',
      event_action_display_name: '點擊'
    },
    clickNormal: {
      event_category: '圖片',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 圖片文字
  imagetext: {
    view: {
      event_category: '圖片文字'
    },
    clickNormal: {
      event_category: '圖片文字',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 圖片輪播
  carousel: {
    view: {
      event_category: '圖片輪播'
    },
    clickNormal: {
      event_category: '圖片輪播',
      event_action: 'normal',
      event_action_display_name: '點擊'
    },
    clickCarousel: {
      event_category: '圖片輪播',
      event_action: 'carousel',
      event_action_display_name: '換圖點擊'
    }
  },
  // 商品主圖
  'product-carousell': {
    view: {
      event_category: '商品主圖'
    },
    // 圖片輪播換圖點擊
    clickCarousel: {
      event_category: '商品主圖',
      event_action: 'carousel',
      event_action_display_name: '換圖點擊'
    }
  },
  // 商品細節
  'product-info': {
    view: {
      event_category: '商品細節'
    },
    // 商品規格點擊
    clickVariant: {
      event_category: '商品細節',
      event_action: 'variant',
      event_action_display_name: '商品規格點擊'
    },
    // 加入購物車點擊
    clickAddToCart: {
      event_category: '商品細節',
      event_action: 'add_to_cart',
      event_action_display_name: '加入購物車'
    },
    // 收藏商品點擊
    clickAddToWishlist: {
      event_category: '商品細節',
      event_action: 'add_to_wishlist',
      event_action_display_name: '收藏商品'
    }
  },
  // 文字元件
  'draft-text': {
    view: {
      event_category: '文字'
    },
    clickNormal: {
      event_category: '文字',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 臉書牆元件
  'facebook-wall': {
    view: {
      event_category: '臉書牆'
    }
  },
  // 社群分享元件
  'social-media': {
    view: {
      event_category: '社群分享'
    },
    shareFacebook: {
      event_category: '社群分享',
      event_action: 'facebook',
      event_action_display_name: 'Facebook'
    },
    shareX: {
      event_category: '社群分享',
      event_action: 'x',
      event_action_display_name: 'X'
    },
    shareLine: {
      event_category: '社群分享',
      event_action: 'line',
      event_action_display_name: 'LINE'
    },
    shareWechat: {
      event_category: '社群分享',
      event_action: 'wechat',
      event_action_display_name: 'WeChat'
    }
  },
  // 影片元件
  'video-core': {
    view: {
      event_category: '影片'
    },
    clickPlay: {
      event_category: '影片',
      event_action: 'play',
      event_action_display_name: '播放影片'
    }
  },
  // 選選樂元件
  activity: {
    view: {
      event_category: '選選樂'
    },
    clickProduct: {
      event_category: '選選樂',
      event_action: 'product',
      event_action_display_name: '商品點擊'
    },
    clickAddToCart: {
      event_category: '選選樂',
      event_action: 'add_to_cart',
      event_action_display_name: '加入購物車'
    }
  },
  // 商品列表-預設 (/products（商品列表頁） or /products?search=xxx（搜尋商品）)
  products: {
    view: {
      event_category: '商品列表-預設'
    },
    clickProduct: {
      event_category: '商品列表-預設',
      event_action: 'product',
      event_action_display_name: '商品點擊'
    },
    clickAddToCart: {
      event_category: '商品列表-預設',
      event_action: 'add_to_cart',
      event_action_display_name: '加入購物車'
    },
    // 立即購買點擊
    clickBuyNow: {
      event_category: '商品列表-預設',
      event_action: 'add_to_cart_and_begin_checkout',
      event_action_display_name: '立即購買'
    },
    clickAddToWishlist: {
      event_category: '商品列表-預設',
      event_action: 'add_to_wishlist',
      event_action_display_name: '收藏商品'
    },
    clickPagination: {
      event_category: '商品列表-預設',
      event_action: 'pagination',
      event_action_display_name: '換頁點擊'
    }
  },
  // 商品列表元件
  'products-controlled': {
    view: {
      event_category: '商品列表'
    },
    clickProduct: {
      event_category: '商品列表',
      event_action: 'product',
      event_action_display_name: '商品點擊'
    },
    clickAddToCart: {
      event_category: '商品列表',
      event_action: 'add_to_cart',
      event_action_display_name: '加入購物車'
    },
    // 立即購買點擊
    clickBuyNow: {
      event_category: '商品列表',
      event_action: 'add_to_cart_and_begin_checkout',
      event_action_display_name: '立即購買'
    },
    clickAddToWishlist: {
      event_category: '商品列表',
      event_action: 'add_to_wishlist',
      event_action_display_name: '收藏商品'
    },
    clickPagination: {
      event_category: '商品列表',
      event_action: 'pagination',
      event_action_display_name: '換頁點擊'
    }
  },
  // 商品照片集元件
  'product-collections': {
    view: {
      event_category: '商品照片集'
    },
    clickNormal: {
      event_category: '商品照片集',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 商品文字元件
  'product-draftText': {
    view: {
      event_category: '商品文字'
    },
    // 文字點擊
    clickNormal: {
      event_category: '商品文字',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 商品內容元件
  'product-content': {
    view: {
      event_category: '商品內容'
    },
    // 商品規格點擊
    clickVariant: {
      event_category: '商品內容',
      event_action: 'variant',
      event_action_display_name: '商品規格點擊'
    },
    // 圖片放大點擊
    clickImage: {
      event: MEEPSHOP_EVENT.click,
      event_category: '商品內容',
      event_action: 'image',
      event_action_display_name: '圖片放大瀏覽'
    },
    // 圖片輪播換圖點擊
    clickCarousel: {
      event_category: '商品內容',
      event_action: 'carousel',
      event_action_display_name: '換圖點擊'
    },
    // 加入購物車點擊
    clickAddToCart: {
      event_category: '商品內容',
      event_action: 'add_to_cart',
      event_action_display_name: '加入購物車'
    },
    // 立即購買點擊
    clickBuyNow: {
      event_category: '商品內容',
      event_action: 'add_to_cart_and_begin_checkout',
      event_action_display_name: '立即購買'
    },
    // 收藏商品點擊
    clickAddToWishlist: {
      event_category: '商品內容',
      event_action: 'add_to_wishlist',
      event_action_display_name: '收藏商品'
    }
  },
  // 商品影片元件
  'product-video': {
    view: {
      event_category: '商品影片'
    },
    // 播放點擊
    clickPlay: {
      event_category: '商品影片',
      event_action: 'play',
      event_action_display_name: '播放影片'
    }
  },
  // 商品問答元件
  'product-service': {
    view: {
      event_category: '商品問答'
    },
    // 輸入框點擊
    clickNormal: {
      event_category: '商品問答',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 語法元件
  iframe: {
    view: {
      event_category: '語法'
    },
    clickNormal: {
      event_category: '語法',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 臉書按讚
  'social-thumbs': {
    view: {
      event_category: '臉書按讚'
    }
  },
  googlemap: {
    view: {
      event_category: '地圖'
    },
    clickNormal: {
      event_category: '地圖',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  // 全站廣告元件
  'global-carousel': {
    view: {
      event_category: '全站廣告'
    },
    clickNormal: {
      event_category: '全站廣告',
      event_action: 'normal',
      event_action_display_name: '點擊'
    }
  },
  divider: {
    view: {
      event_category: '間距'
    } // 分隔線，不會列入點擊事件追蹤項目

  },
  menu: {
    view: {
      event_category: '選單'
    } // 選單，不會列入點擊事件追蹤項目

  },
  // 瀏覽追蹤 （舊天眼元件，不帶上 event_category) TODO:後續下架時移除
  viewTracking: {
    view: {}
  }
};
exports.WIDGET_EVENT = WIDGET_EVENT;
var GodsEyeContext = /*#__PURE__*/(0, _react.createContext)({
  handleTrack: function handleTrack(_value) {
    return _emptyFunction["default"];
  },
  trackProperties: {}
});
exports.GodsEyeContext = GodsEyeContext;

function addEventLabel(obj, eventLabel, elementId) {
  // Check if the input is an object
  // 避免都使用同一個 reference，造成所有事件都會取得最後一個相同的元件 id (e.g. 多個文字元件送出時只會送出最後一個文字元件的 id)，深拷貝解決問題
  var newObj = JSON.parse(JSON.stringify(obj || null));

  if ((0, _typeof2["default"])(newObj) === 'object' && newObj !== null) {
    // Loop through each key in the object
    Object.keys(newObj).forEach(function (key) {
      if ((0, _typeof2["default"])(newObj[key]) === 'object') {
        newObj[key].event_label = eventLabel;
        newObj[key].event_element = elementId; // Recursively call the function for nested objects

        addEventLabel(newObj[key], eventLabel, elementId);
      }
    });
  }

  return newObj;
}

var useGodsEyeTracking = function useGodsEyeTracking(_ref) {
  var eventLabel = _ref.eventLabel,
      moduleId = _ref.moduleId,
      module = _ref.module;
  var adTrack = (0, _react.useContext)(_AdTrack["default"]);
  var trackProperties = (0, _react.useMemo)(function () {
    return addEventLabel(WIDGET_EVENT[module], eventLabel, moduleId) || {};
  }, [module, moduleId, eventLabel]);

  var clickTracking = function clickTracking(trackEvent) {
    if (!trackEvent) return;
    adTrack.custom(MEEPSHOP_EVENT.click, trackEvent.event_label, trackEvent.event_category, {
      eventElement: trackEvent.event_element,
      eventAction: trackEvent.event_action
    });
  };

  var viewTracking = function viewTracking(trackEvent) {
    if (!trackEvent) return;
    setTimeout(function () {
      return adTrack.custom(MEEPSHOP_EVENT.view, trackEvent.event_label, trackEvent.event_category, {
        eventElement: trackEvent.event_element
      });
    }, 1500); // 因 window.fbq & window.gtag 需要時間載入，故 setTimeout，否則會有最上層資料沒被追蹤到
  };

  return {
    clickTracking: clickTracking,
    viewTracking: viewTracking,
    trackProperties: trackProperties
  };
};

var GodsEyeProvider = function GodsEyeProvider(_ref2) {
  var children = _ref2.children,
      customTracking = _ref2.customTracking,
      module = _ref2.module,
      moduleId = _ref2.moduleId,
      moduleIndex = _ref2.moduleIndex;
  // eventLabel 元件名稱： {元件類別名稱}_{element_id 前四位元亂碼}
  var eventLabel = (customTracking === null || customTracking === void 0 ? void 0 : customTracking.eventLabel) || "".concat(WIDGET_TITLE[module], "_").concat(moduleId === null || moduleId === void 0 ? void 0 : moduleId.slice(0, 4));

  var _useGodsEyeTracking = useGodsEyeTracking({
    moduleId: "".concat(moduleIndex, "_").concat(moduleId),
    // event_element 使用 ${index}_${id} 作為 elementId， index 用於後台報表呈現時可以知道當下的 widget 順序
    module: module,
    eventLabel: eventLabel
  }),
      viewTracking = _useGodsEyeTracking.viewTracking,
      clickTracking = _useGodsEyeTracking.clickTracking,
      trackProperties = _useGodsEyeTracking.trackProperties;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isTriggered = _useState2[0],
      setIsTriggered = _useState2[1];

  var value = (0, _react.useMemo)(function () {
    return {
      trackProperties: trackProperties,
      handleTrack: clickTracking
    };
  }, [trackProperties, clickTracking]);
  return /*#__PURE__*/_react["default"].createElement(GodsEyeContext.Provider, {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_reactVisibilitySensor["default"], {
    active: !isTriggered,
    onChange: function onChange(isVisible) {
      if (isVisible) {
        viewTracking(trackProperties.view);
        setIsTriggered(true);
      }
    },
    partialVisibility: true
  }, children));
};

exports.GodsEyeProvider = GodsEyeProvider;

function useGodsEyeContext() {
  var contextValue = (0, _react.useContext)(GodsEyeContext);

  if (contextValue === undefined) {
    throw new Error('useGodsEyeContext must be used within a GodsEyeProvider');
  }

  return contextValue;
}

var _default = GodsEyeContext;
exports["default"] = _default;